import { mapState } from 'vuex';
export default {
  name: 'NiotaClassicGwMgmtAlertConfig',
  props: {
    formItem: {
      type: Object,
      required: true
    },
    bridges: {
      type: Array,
      required: true
    }
  },
  data: function () {
    return {
      accountName: undefined,
      accountFieldDisabled: true
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions', 'UiTheme']),
    requiredRule() {
      return [v => !!v || this.$i18n_t('Common.fieldRequired')];
    },
    senderMailRule() {
      return [v => !v || /^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+)$/.exec(v) !== null || this.$i18n_t('Common.emailValid')];
    },
    emailRules() {
      return [v => !!v && /^(([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+),?[ ]*)+$/.exec(v) !== null || this.$i18n_t('Common.emailValid')];
    }
  }
};